<template>
  <div class="timeline-rightKey" v-if='boxData.judgeBox' :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }" @mousedown="stopDocument($event)">
    <div class="camere-rightKey">
      <div @click="deleteCamera">删除镜头</div>
    </div>
  </div>
</template>
<script>
import popup from '../mixins/popup'

export default {
  name: 'timelineRightKey',
  mixins: [popup],
  data() {
    return {
      popupType: 'timelineRightKey',
    }
  },
  watch: {
    'boxData.judgeBox': function (val) {
      if(val) {
        this.initData()
      }
    }
  },
  methods: {
    initData() {
      return;
    },
    deleteCamera () {
      this.$bus.emit('camera_delete');
      this.close()
    }
  }
}
</script>
<style lang="scss" scoped>
.timeline-rightKey {
  position: fixed;
  top: 0;
  left: 0;
  width: 80px;
  border-radius: 3px;
  background: #fff;
  overflow: hidden;
  font-size: 13px;
  box-shadow: 1px 2px 4px 1px #d8dee9;
  color: #474261;
}
.camere-rightKey {
  height: 30px;
  width: 100%;
  line-height: 30px;

  > div {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/timelineRightKey.vue